import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TutorialDialogComponent } from '../core/components/tutorial-dialog/tutorial-dialog.component';
import { CustomerModel } from '../models/customer.model';
import { SettingsService } from './settings.service';

@Injectable()
export class TutorialService {

  constructor(private dialog: MatDialog, private settings_service: SettingsService) { }

  openTutorial(url: string, customer?: CustomerModel): void {
    if (customer != null && customer.tutorial_watched != null) {
      return;
    }

    const dialogRef = this.dialog.open(TutorialDialogComponent, {
      data: { url },
      width: '900px',
      panelClass: ['mat-dialog-override', 'tutorial-video-dialog']
    });

    if (customer != null) {
      dialogRef.afterClosed().subscribe(() => {
        this.settings_service.PutTutorial(customer).subscribe();
      });
    }
  }
}
